import type { BadgeValue } from '@/hooks/useNavBadges'

/**
 * Nav indicator: a gold count pill for numeric badges (e.g. claimable rewards)
 * or a red dot for a plain boolean alert. Renders nothing for 0 / false.
 * Expects a `position: relative` inline-flex wrapper around the icon.
 */
export function NavBadge({ value, size = 'md' }: { value: BadgeValue; size?: 'sm' | 'md' }) {
  if (typeof value === 'number') {
    if (value <= 0) return null
    const dim = size === 'sm' ? 14 : 16
    return (
      <span
        style={{
          position: 'absolute',
          top: -7,
          right: -9,
          minWidth: dim,
          height: dim,
          padding: '0 4px',
          borderRadius: 999,
          background: 'var(--gradient-gold)',
          color: 'var(--gold-contrast)',
          border: '1.5px solid var(--bg-primary)',
          fontSize: size === 'sm' ? '0.6rem' : '0.64rem',
          fontWeight: 800,
          fontVariantNumeric: 'tabular-nums',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {value > 99 ? '99+' : value}
      </span>
    )
  }

  if (!value) return null
  const d = size === 'sm' ? 7 : 8
  return (
    <span
      style={{
        position: 'absolute',
        top: -2,
        right: -4,
        width: d,
        height: d,
        borderRadius: '50%',
        background: 'var(--danger)',
        border: '1.5px solid var(--bg-primary)',
      }}
    />
  )
}
